export default __webpack_public_path__ + "static/media/flip-camera.342ae809.svg";